import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/useAuth";

export default function AuthDegraded() {
  const { signOut } = useAuth();
  return (
    <div className="min-h-screen gradient-dark flex items-center justify-center p-6">
      <div className="text-center space-y-4">
        <h1 className="text-2xl text-white">Service temporarily unavailable</h1>
        <p className="text-gray-light max-w-md">
          Authentication and role services are currently degraded. Please try again shortly.
        </p>
        <div className="pt-2">
          <Button onClick={signOut}>Sign out</Button>
        </div>
      </div>
    </div>
  );
}


